import Imatge, { hasImatge } from 'components/3catinfo/Imatge';
import Enllac from 'components/3catinfo/Enllac';
import Icona from 'components/3catinfo/ui/Icona';
import styles from './destacatPrograma.module.scss';

const _showIconaLink = () => {
    return (
        <div className={styles.icona_link}>
            <span className={styles.iconaWrapper}>
                <Icona
                    icona='ic_linkexterior'
                    className={styles.link}
                    alt='link'
                    isBlanc={true}
                    mida={112}
                    inline={true}
                    ariaHidden={true}
                />
            </span>
        </div>
    );
};

const DestacatPrograma = (props) => {
    const { item, index, infoBlocRedl, mostraIcona, novaFinestra } = props;
    const { id, titol, imatges, url, tipologia, nom_friendly } = item;
    const hasImatges = hasImatge(imatges, 'web_programes_destacats', null, null);
    const route =
        tipologia === 'DTY_VIDEO_MM'
            ? { slug: nom_friendly, type: 'web_3cat_item_video', id }
            : { href: url, type: 'web_3cat_programa' };

    const indexMarcatge = index || 1;
    const marcatgeAudienciesClick = infoBlocRedl
        ? `Tira:${indexMarcatge}:${infoBlocRedl?.descripcio ? infoBlocRedl?.descripcio?.replace(':', '.') : ''}`
        : '';

    return item ? (
        <Enllac
            route={route}
            novaFinestra={novaFinestra}
            className={styles.poster_destacat_programa}
            dataTestId={`poster-destacat-informatius-${id}`}
            marcatgeAudienciesClick={marcatgeAudienciesClick}
        >
            <div className={styles.wrapper}>
                <div className={styles.imatgeWrapper}>
                    {hasImatges && (
                        <Imatge
                            className={styles.imatge}
                            imatges={imatges}
                            tipus='web_programes_destacats'
                            alt={titol}
                            layout='fill'
                            objectFit='cover'
                        />
                    )}
                </div>
                {mostraIcona && _showIconaLink()}
            </div>
        </Enllac>
    ) : (
        <></>
    );
};

export default DestacatPrograma;
